import { Fragment } from 'react'
import { LayoutDashboard } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { SidebarCompaniesSection } from '@/features/companies/components/SidebarCompaniesSection'
import { cn } from '@/lib/cn'
import { getPermissionForPath } from '@/config/routePermissions'

export interface SidebarDashboardAndCompaniesProps {
  showLabels: boolean
  can: (module: string, action: string) => boolean
  permissionsLoading: boolean
  baseLinkClass: string
  activeClass: string
  inactiveClass: string
  childLinkClass: string
  childInactiveClass: string
  childActiveClass: string
}

export function SidebarDashboardAndCompanies({
  showLabels,
  can,
  permissionsLoading,
  baseLinkClass,
  activeClass,
  inactiveClass,
  childLinkClass,
  childInactiveClass,
  childActiveClass,
}: SidebarDashboardAndCompaniesProps): React.ReactElement {
  const permission = getPermissionForPath('/dashboard')
  const dashboardEnabled =
    !permission ||
    (!permissionsLoading && can(permission.module, 'read'))

  const companiesProps = {
    showLabels,
    can,
    permissionsLoading,
    baseLinkClass,
    activeClass,
    inactiveClass,
    childLinkClass,
    childInactiveClass,
    childActiveClass,
  }

  return (
    <Fragment key="dashboard-companies">
      {dashboardEnabled && (
        <NavLink
          to="/dashboard"
          title="Dashboard"
          className={({ isActive, isPending }) =>
            cn(baseLinkClass, isActive || isPending ? activeClass : inactiveClass)
          }
        >
          {() => {
            return (
              <>
                <LayoutDashboard
                  className="relative z-[1] h-[18px] w-[18px] shrink-0"
                />
                <span
                  className={cn(
                    'min-w-0 flex-1 overflow-hidden whitespace-nowrap transition-all duration-200',
                    !showLabels && 'max-w-0 opacity-0'
                  )}
                >
                  Dashboard
                </span>
              </>
            )
          }}
        </NavLink>
      )}
      <SidebarCompaniesSection {...companiesProps} />
    </Fragment>
  )
}

SidebarDashboardAndCompanies.displayName = 'SidebarDashboardAndCompanies'
